import { SetGetReplenishment } from './thunk/setGetReplenishment';

export const Thunks ={
    SetGetReplenishment
}